(function ($, Drupal) {
  Drupal.behaviors.clearwaterChoices = {
    attach: function (context) {
      if (typeof Choices === 'undefined') return;

      $('select.js-choices', context).each(function () {
        if (this.dataset.choicesInit === '1') return;

        const instance = new Choices(this, {
          searchEnabled: false,
          shouldSort: false,
          allowHTML: false,
          itemSelectText: ''
        });
        const container = instance && instance.containerOuter && instance.containerOuter.element;
        if (container) container.classList.add('contact-choices');

        this.dataset.choicesInit = '1';
      });
    }
  };
})(jQuery, Drupal);
